import { combineReducers } from "redux";

export const selectedMessageReducer = (selectedMessage = null, action: { type: string; payload: any; }) => {
    if (action.type === 'MESSAGE_SELECTED') {
        return action.payload;
    }
    return selectedMessage;
}

export const messagesListReducer = (messages = [], action: { type: string; payload: any; }) => {
    if (action.type === 'FETCH_MESSAGES') {
        return action.payload
    }
    return messages;
};

export const allSentNotificationsListReducer = (sentMessages = [], action: { type: string; payload: any; }) => {
    if (action.type === 'FETCH_ALL_SENTNOTIFICATIONS') {
        return action.payload
    }
    return sentMessages;
};

export const allSentMessagesListReducer = (allMessages = [], action: { type: string; payload: any; }) => {
    if (action.type === 'FETCH_ALL_SENTMESSAGES') {
        return action.payload
    }
    return allMessages;
};

export const scheduledMessagesReducer = (scheduledMessages = [], action: { type: string; payload: any; }) => {
    if (action.type === 'FETCH_SCHEDULED_MESSAGES') {
        return action.payload
    }
    return scheduledMessages;
};

export const draftmessagesListReducer = (draftMessages = [], action: { type: string; payload: any; }) => {
    if (action.type === 'FETCH_DRAFTMESSAGES') {
        return action.payload
    }
    return draftMessages;
};

export default combineReducers({
    messagesList: messagesListReducer,
    draftMessagesList: draftmessagesListReducer,
    selectedMessage: selectedMessageReducer,
    scheduledMessages: scheduledMessagesReducer,  
    allNotificationMessages: allSentNotificationsListReducer,
    allMessages: allSentMessagesListReducer
});